<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span {{ codigoEmpleado ? 'Libros de vacaciones' : 'Mis libros de vacaciones' }}
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close
    .body
      table.table.is-striped.is-bordered
        thead
          th Periodo
          th Inicio - Fin
          th Dias por tomar
          th Dias tomados
        tbody(
          name="table-row"
          is="transition-group"
        )
          tr.row-table(
            v-for="(o,index) in libros"
            :key="index"
            :class="{ active: o.activo }"
            @click="mostrarHojas(o)"
          )
            td {{ o.periodo }}
            td
              .td-wrapper.hint--top(:aria-label="'Libro: ' + o.id")
                .dates-wrapper
                  span {{ o.fechaInicio }}
                  span.hide-break-1 &nbsp;-&nbsp;
                  span {{ o.fechaFin }}
            td {{ o.diasPorTomar }}
            td {{ o.diasTomados }}
      loading(v-if="isLoading")
    transition(name="fade")
      div(
        v-if="periodoSeleccionado"
      )
        .title
          span Detalle del libro {{ periodoSeleccionado }}

        transition(name="fade")
          .loading(
            v-if="loadingHojas"
            key="loading"
          )
            span.icon
              i.fa.fa-spin.fa-spinner
          .hojas(
            v-else
            key="list-hojas"
          )
            article.message(
              v-if="hojas.length === 0"
              key="message-not-hojas"
            )
              .message-body
                | No hay hojas en este libro
            div(
              v-else
              key="table-hojas"
              :style="codigoEmpleado ? 'overflow-y: auto; height:10em;' : ''"
            )
              table.table.is-striped.is-bordered.detalle-wrapper
                thead
                  //- th Id de vacaciones
                  th Fecha
                  th Dias tomados
                  th Motivo
                tbody(
                  name="table-row"
                  is="transition-group"
                )
                  tr.row-table(
                    v-for="(o,index) in hojas"
                    :key="index"
                    :class="{ resta: o.signo === '-', suma: o.signo === '+' }"
                  )
                    //- td {{ o.idVacaciones }}
                    td
                      .td-wrapper.hint--top(:aria-label="'Vacaciones: ' + o.idVacaciones")
                        .dates-wrapper
                          span {{ o.fechaInicio }}
                          span.hide-break-1 &nbsp;-&nbsp;
                          span {{ o.fechaFin }}
                    //- td {{ o.fechaInicio }} - {{ o.fechaFin }}
                    td {{ o.diasTomados }}
                    td {{ o.motivo }}
              //- loading(v-if="isLoading")


</template>

<script>
import { apiGet, notify } from '../util/general'

export default {
  name: 'lista_libros_vacaciones_component',
  props: {
    codigoEmpleado: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      libros: [],
      hojas: [],
      periodoSeleccionado: 0,
      loadingHojas: false,
      isLoading:true
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      if (vm.codigoEmpleado) {
        obj.codigo = vm.codigoEmpleado
      }
      apiGet(vm, '/vacaciones/libro', obj, function (data) {
        vm.libros = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    mostrarHojas (libro) {
      if (libro.periodo !== this.periodoSeleccionado) {
        let vm = this
        this.periodoSeleccionado = libro.periodo
        this.hojas = []
        this.loadingHojas = true

        var obj = {
          id: libro.id
        }

        apiGet(vm, '/vacaciones/hoja', obj, function (data) {
          vm.hojas = data.lista
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.loadingHojas = false
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .overflow-y-scroll
    overflow-y: auto;
  .contenedor-interno
    .close
      position absolute
      right 5px
      top 5px
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      padding-right: 10px
      padding-left: 10px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    cursor pointer

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  tr
    &.active
      background-color #c1debe !important
    &.resta
      background-color #ffd6d6 !important
    &.suma
      background-color #c1debe !important

  td
    .email
      font-size 12px
      color #9a9a9a

  @media (max-width 694px)
    td
      text-align: center
      vertical-align: middle
      .contenedor-acciones
        flex-direction: column
        .button
          margin-bottom 5px
          &:last-child
            margin-bottom 0px

  @media (max-width 583px)
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle

        .td-wrapper
          display flex
          justify-content: center
          align-items: center
          flex-direction: column

          .dates-wrapper
            display: flex
            flex-direction: column
    .show-break-1
      display initial

    .hide-break-1
      display none
</style>



// WEBPACK FOOTER //
// Component_Lista_Libros_Vacaciones.vue?26e7ebb0